import React from 'react';

const FormInput = ({
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
}) => (
  <>
    <input
      className="text-field-14 form_text w-input"
      maxLength={256}
      name={name}
      placeholder={placeholder}
      type={type}
      value={value}
      onChange={onChange}
    />
   
  </>
);

export default FormInput;